// The company's brand colours on the portal quote page (/public/quote/:token) and pay page
// (/payment/:token) — operator ruling 2026-10-30, item 8: "same treatment as the Business Page".
//
// The shades come from the ONE owner, shared-ui documentBrand.js, which already returns null for
// an empty value or a column default ('#3B82F6' theme, '#6B7280' secondary), so a company that
// never picked a colour gets null here and every caller keeps its stock classes unchanged.
//   primary  companies.theme_color: the company name and the pay page header (like the Business
//            Page header). accentText is >= 4.5:1 on white; onAccent is the contrast-checked text
//            colour ON the accent fill.
//   cta      the call-to-action button: the secondary colour when picked, else the primary (the
//            same fallback the quote/invoice emails use).
//   rule     the accent rule under the header: the secondary colour (the Business Page's rule).
import { documentBrandColor, documentSecondaryColor } from '@tradesmatepro/shared-ui';

export function portalBrand(company) {
  const primary = documentBrandColor(company?.theme_color);
  const secondary = documentSecondaryColor(company?.secondary_color);
  return { primary, cta: secondary || primary, rule: secondary };
}

// Inline style for a branded button, or undefined (keep the stock classes).
export const brandButtonStyle = (shades) => (shades
  ? { backgroundColor: shades.accent, backgroundImage: 'none', color: shades.onAccent }
  : undefined);
